module.exports = __webpack_public_path__ + "img/card.95a98bd7.svg";